import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import settingLink from "./setting-link";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { isEmpty, map, size } from "lodash";
import Moment from 'react-moment';

import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    FormGroup,
    Label,
    Input,
    Button,
    Offcanvas,
    OffcanvasHeader,
    OffcanvasBody
} from "reactstrap"
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import CustomerSupportMenu from "./menu/customer-supoort-menu";
import ActionDelete from "components/buttons/actionDelete";
import { API_URL } from "helpers/app_url";
import axios from "axios";
import PhoneInputField from "components/dropdowns/PhoneInputField";
import SafeField from "helpers/SafeField";
import RsAdNewV2 from "components/buttons/Adnew-v2";
import SaveButton from "components/buttons/save";
import { UPLOADTEXT } from "constants/layout";
import { BlobServiceClient } from '@azure/storage-blob';
import Swal from 'sweetalert2'
import { azureConfig } from "helpers/azureConfig";
import ActionEditLink from "components/buttons/actionEditlink";
class SupportTicket extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ticketTypes: [],
            tickets:[]

        }
        this.toggleAddNew = this.toggleAddNew.bind(this);
        this.ticketDetail = this.ticketDetail.bind(this);
    }
    addToggle() {
        this.setState(prevState => ({
            isAddNew: !prevState.isAddNew
        }));
    }
     viewTicket() {
        this.setState(prevState => ({
            isView: !prevState.isView
        }));
    }
    ticketDetail() {
        this.setState({ ticket: "", isEdit: false, isView: !this.state.isView });
        this.viewTicket();
    }
    toggleAddNew() {
        this.setState({ isAddNew: !this.state.isAddNew });
        //this.addToggle();
    }
    ticketDetail = arg => {
  const ticket = arg;
  this.setState({
    ticket: {
      id:ticket.id,
      supportTicketId: ticket.supportTicketId,
      agentId: ticket.agentId,
      ticketNo: ticket.ticketNo,
      subject: ticket.subject,
      description: ticket.description,
      issuedDate: ticket.issuedDate,
      closingDate: ticket.closingDate,
      ticketStatus: ticket.ticketStatus,
      ticketType: ticket.ticketType,
      pageUrl: ticket.pageUrl,
      ticketAttachment: ticket.ticketAttachment,
    
    },
    isEdit: true,
  });
  this.viewTicket();
};
    fetchType() {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj?.resultData?.bearerToken;
        const headers = {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        };
        const params = {
            agentId: localStorage.getItem("userId"),
            clientId: 0
        };
        axios
            .get(`${API_URL}SupportTicketType/allforagent`, { headers, params })
            .then((response) => {
                this.setState({ ticketTypes: response.data, loading: false });
            })
            .catch((error) => {
                this.setState({ error: error.message, loading: false });
            });
    }

    fetchSupportTicket() {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj?.resultData?.bearerToken;
        const headers = {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        };
        const params = {
            agentId: localStorage.getItem("userId"),
        };
        axios
            .get(`${API_URL}SupportTicket/allforagent`, { headers, params })
            .then((response) => {
                this.setState({ tickets: response.data, loading: false });
            })
            .catch((error) => {
                this.setState({ error: error.message, loading: false });
            });
    }
    componentDidMount() {
        this.fetchType();
        this.fetchSupportTicket();
    }
    handleSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            const payload = {
                agentId: parseInt(values.agentId),
                ticketStatus: parseInt(values.ticketStatus),
                ticketType: parseInt(values.ticketType),
                ticketNo: values.ticketNo,
                subject: values.subject,
                description: values.description,
                issuedDate: values.issuedDate,
                closingDate: values.closingDate,
                pageUrl: values.pageUrl,
                ticketAttachment: values.ticketAttachment
            }
            toast.loading('Please wait...')
            const obj = JSON.parse(localStorage.getItem("authUser"));
            const token = obj?.resultData?.bearerToken;
            const response = await axios.post(
                `${API_URL}SupportTicket`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.success) {
                toast.dismiss();
                toast.success('Saved successfully.')
                this.fetchSupportTicket();
                this.addToggle();
                resetForm();
            } else {
                toast.dismiss();
                toast.warn(response.data.validationErrors[0] || 'some issue please try after some time')
            }
        } catch (error) {
            console.error("Error submitting form:", error);
        } finally {
            setSubmitting(false);
        }
    };
    handleDelete = (serviceId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won’t be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then((result) => {
            if (result.isConfirmed) {
                const obj = JSON.parse(localStorage.getItem("authUser"));
                const token = obj?.resultData?.bearerToken;

                axios
                    .delete(`${API_URL}SupportTicket/${serviceId}`, {
                        headers: { Authorization: `Bearer ${token}` },
                    })
                    .then(() => {
                        Swal.fire("Deleted!", "Deleted successfully", "success");
                        this.setState((prevState) => ({
                            tickets: prevState.tickets.filter((s) => s.id !== serviceId),
                        }));
                    })
                    .catch(() => {
                        Swal.fire("Error!", "Something went wrong.", "error");
                    });
            }
        });
    };
  async handleFileChange(event, setFieldValue) {
      const file = event.currentTarget.files[0];
      if (file) {
        const maxSize = 5 * 1024 * 1024;
        const allowedTypes = ['application/pdf', 'application/msword', 'image/jpeg', 'image/png'];
        const allowedExtensions = ['.pdf', '.doc', '.jpg', '.jpeg', '.png', '.webp'];
        const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
        if (!allowedTypes.includes(file.type) || !allowedExtensions.includes(fileExtension)) {
          Swal.fire({
            title: 'File type or extension not allowed',
            text: 'Please upload a PDF, DOC, JPG, or PNG file.',
            icon: 'warning',
            confirmButtonText: 'OK',
          });
          //alert('Invalid file type. Please upload a PDF, DOC, JPG, or PNG file.');
          return;
        }
        if (file.size > maxSize) {
          Swal.fire({
            title: 'Size not allowed',
            text: 'Please Upload Maximum 5MB File',
            icon: 'warning',
            confirmButtonText: 'OK',
          });
         
        }
        this.setState({ btnloading: true });
        const sasToken = azureConfig.sasToken;
        const containerName = azureConfig.containerName;
        const storageAccountName = azureConfig.storageAccountName;
        const fileName = `${Date.now()}_${file.name}`;
        const blobServiceClient = new BlobServiceClient(
          `https://${storageAccountName}.blob.core.windows.net?${sasToken}`
        );
        const containerClient = blobServiceClient.getContainerClient(containerName);
        const blobClient = containerClient.getBlockBlobClient(fileName);
  
        try {
          await blobClient.uploadBrowserData(file, {
            blobHTTPHeaders: { blobContentType: file.type }
          });
  
       
          if (setFieldValue) {
            const fileUrl = `https://${storageAccountName}.blob.core.windows.net/${containerName}/${fileName}`;
            setFieldValue(`ticketAttachment`, fileUrl);
            this.setState({ fileUploaded: true });
          }
        } catch (error) {
          console.error('Error uploading file:', error);
  
        }
      }
    }
      handleUpdate = async (values, { setSubmitting, resetForm }) => {
        try {
            const payload = {
                id:parseInt(values.id),
                 agentId: parseInt(values.agentId),
                    ticketNo: values.ticketNo,
                    subject: values.subject,
                    description: values.description,
                    issuedDate: values.issuedDate,
                    closingDate: values.closingDate,
                    ticketStatus: parseInt(values.ticketStatus),
                    ticketType: parseInt(values.ticketType),
                    pageUrl: values.pageUrl,
                    ticketAttachment: values.ticketAttachment,
            }
           
            toast.loading('Please wait...')
            const obj = JSON.parse(localStorage.getItem("authUser"));
            const token = obj?.resultData?.bearerToken;
            const response = await axios.put(
                `${API_URL}SupportTicket`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.success) {
                toast.dismiss();
                toast.success('Updated successfully.')
                this.fetchSupportTicket();
                this.viewTicket();
                
            } else {
                toast.dismiss();
                toast.warn(response.data.validationErrors[0] || 'some issue please try after some time')
            }
        } catch (error) {
            console.error("Error submitting form:", error);
        } finally {
            setSubmitting(false);
        }
    };
    render() {
        const { ticketTypes, tickets, ticket } = this.state;
          const allLocal = localStorage.getItem("localData");
        const localization = JSON.parse(allLocal);
        return (
            <React.Fragment>
                <ToastContainer autoClose={2000} />
                <div className="page-content">
                    <MetaTags>
                        <title>Agent Profile | Realty Space</title>
                    </MetaTags>
                    <Container fluid>


                        <Row className="mb20">
                            <Col xl="6">
                                <Breadcrumbs
                                    title={this.props.t("Setting")}
                                    breadcrumbItem={this.props.t("Support ticket")}
                                />

                            </Col>
                            <Col xl="6" className="text-end">
                                <div className="pt-2 mt-2 d-flex justify-content-center justify-content-xl-end flex-wrap">

                                    <RsAdNewV2 to="#" onClick={this.toggleAddNew} className="text-purple" iconClass="bx bx-plus-medical">Add new</RsAdNewV2>{" "}

                                </div>
                            </Col>
                        </Row>
                        <Row>


                            <Col xl="12">

                                <Card>
                                    <CardBody>
                                        <h5 className="card-title"></h5>
                                        <div className="table-responsive">
                                            <table className="table table-bordered border-primary align-middle table-nowrap mb-0">
                                                <thead className="">
                                                    <tr>
                                                         <th>#</th>
                                                        <th>Date</th>
                                                        <th>Section</th>


                                                        <th>Subject</th>
                                                        <th>Status</th>
                                                        <th></th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                      {tickets.map((ticket, index) => (
                                                        <tr key={index}>
                                                            <td>{index+1}</td>
                                                            <td><Moment format="DD MMM YYYY">{ticket.issuedDate}</Moment></td>
                                                            <td>
                                                                {
                                        localization[
                                          "SupportTicketType_" +
                                            ticket.ticketType
                                        ]
                                      }


                                                            </td>
                                                            <td>{ticket.subject}</td>
                                                            <td>{ticket.ticketStatus}</td>
                                                             <td><ActionEditLink onClick={() => this.ticketDetail(ticket)} />

                                                                <ActionDelete onClick={() => this.handleDelete(ticket.id)} />
                                                             </td>
                                                        </tr>
                                                      ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </CardBody>
                                </Card>




                            </Col>

                        </Row>

                    </Container>
                </div>

                <Offcanvas
                    isOpen={this.state.isAddNew}
                    direction="end"
                    toggle={this.toggleAddNew}
                  
                >
                    <OffcanvasHeader toggle={this.toggleAddNew}>
                        New Template
                    </OffcanvasHeader>
                    <OffcanvasBody>
                        <Formik
                           
                            initialValues={{

                                agentId: localStorage.getItem('userId'),
                                ticketNo:  '',
                                subject: '',
                                description:'',
                                ticketType: '',
                                issuedDate: new Date(),
                                closingDate: null,
                                ticketStatus:0,
                                pageUrl: '',
                                agentId: localStorage.getItem('userId'),
                                isActive: true,
                                ticketAttachment: null,
                            }}
                            validationSchema={Yup.object().shape({

                                subject: Yup.string().required("This is required"),
                                ticketType:Yup.string().required("This is required"),
                            })}

                            onSubmit={this.handleSubmit}

                        >
                            {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                                <Form
                                    className="needs-validation"
                                >


                                    <Row>

                                        <Col md="12">




                                            <FormGroup className="mb-3">
                                                <Label htmlFor="pageUrl">Page URL</Label>
                                                <SafeField
                                                    name="pageUrl"
                                                    className={
                                                        "form-control" +
                                                        (errors.pageUrl && touched.pageUrl
                                                            ? " is-invalid"
                                                            : "")
                                                    }
                                                    onChange={handleChange}
                                                    type="text"
                                                />
                                                <ErrorMessage
                                                    name="pageUrl"
                                                    component="div"
                                                    className="invalid-feedback"
                                                />
                                            </FormGroup>





                                        </Col>
                                        <Col md="12">




                                            <FormGroup className="mb-3">
                                                <Label htmlFor="subject">Subject *</Label>
                                                <SafeField
                                                    name="subject"
                                                    className={
                                                        "form-control" +
                                                        (errors.subject && touched.subject
                                                            ? " is-invalid"
                                                            : "")
                                                    }
                                                    onChange={handleChange}
                                                    type="text"
                                                />
                                                <ErrorMessage
                                                    name="subject"
                                                    component="div"
                                                    className="invalid-feedback"
                                                />
                                            </FormGroup>





                                        </Col>
                                        <Col sm="12">
                                            <FormGroup className="mb-3">
                                                <Label htmlFor="ticketType">
                                                    {this.props.t("Issue section *")}
                                                </Label>
                                                <SafeField as="select" name="ticketType"
                                                    className={
                                                        "form-control" +
                                                        (errors.ticketType && touched.ticketType
                                                            ? " is-invalid"
                                                            : "")
                                                    }

                                                    onChange={handleChange}>
                                                    <option value="">Select</option>
                                                    {map(ticketTypes, (ticketType, classkey) => (
                                                        <option value={ticketType.id} key={classkey}>{ticketType.supportTicketTypeTitle}</option>
                                                    ))}
                                                </SafeField>
                                                <ErrorMessage
                                                    name="ticketType"
                                                    component="div"
                                                    className="invalid-feedback"
                                                />
                                            </FormGroup>
                                        </Col>

                                         <Col sm="12">
                                            <FormGroup className="mb-3">
                                                <Label htmlFor="ticketType">
                                                    {this.props.t("Describe issue")}
                                                </Label>
                                                <SafeField
                                                    name="description"
                                                    className={
                                                        "form-control" +
                                                        (errors.description && touched.description
                                                            ? " is-invalid"
                                                            : "")
                                                    }
                                                    onChange={handleChange}
                                                    as="textarea"
                                                />
                                                <ErrorMessage
                                                    name="description"
                                                    component="div"
                                                    className="invalid-feedback"
                                                />
                                            </FormGroup>
                                        </Col>
                                           <Col sm="12">
                                        <div className="form-group mb-3">
                                            <Label htmlFor="file">Attachment</Label>
                                            <input
                                            type="file"
                                            className="form-control"
                                            onChange={event => this.handleFileChange(event, setFieldValue)}
                                            />
                                            <small className="text-muted font-size-12">{UPLOADTEXT.DFOR}</small>
                                           
                                        </div>
                                        </Col>
                                    </Row>






                                    <div><SaveButton>Save</SaveButton></div>

                                </Form>
                            )}
                        </Formik>

                    </OffcanvasBody>
                </Offcanvas>



                     <Offcanvas
                    isOpen={this.state.isView}
                    direction="end"
                    toggle={this.ticketDetail}
                  
                >
                    <OffcanvasHeader toggle={this.ticketDetail}>
                        Update
                    </OffcanvasHeader>
                    <OffcanvasBody>
                        <Formik
                             enableReinitialize={true}
                            initialValues={{
                                id:ticket?.id,
                                supportTicketId: ticket?.supportTicketId,
                                agentId: ticket?.agentId,
                                ticketNo: ticket?.ticketNo,
                                subject: ticket?.subject,
                                description: ticket?.description,
                                issuedDate: ticket?.issuedDate,
                                closingDate: ticket?.closingDate,
                                ticketStatus: ticket?.ticketStatus,
                                ticketType: ticket?.ticketType,
                                pageUrl: ticket?.pageUrl,
                                ticketAttachment: ticket?.ticketAttachment,
                            }}
                            validationSchema={Yup.object().shape({

                                subject: Yup.string().required("This is required"),
                                ticketType:Yup.string().required("This is required"),
                            })}

                            onSubmit={this.handleUpdate}

                        >
                            {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                                <Form
                                    className="needs-validation"
                                >


                                    <Row>

                                        <Col md="12">




                                            <FormGroup className="mb-3">
                                                <Label htmlFor="pageUrl">Page URL</Label>
                                                <SafeField
                                                    name="pageUrl"
                                                    className={
                                                        "form-control" +
                                                        (errors.pageUrl && touched.pageUrl
                                                            ? " is-invalid"
                                                            : "")
                                                    }
                                                    onChange={handleChange}
                                                    type="text"
                                                />
                                                <ErrorMessage
                                                    name="pageUrl"
                                                    component="div"
                                                    className="invalid-feedback"
                                                />
                                            </FormGroup>





                                        </Col>
                                        <Col md="12">




                                            <FormGroup className="mb-3">
                                                <Label htmlFor="subject">Subject *</Label>
                                                <SafeField
                                                    name="subject"
                                                    className={
                                                        "form-control" +
                                                        (errors.subject && touched.subject
                                                            ? " is-invalid"
                                                            : "")
                                                    }
                                                    onChange={handleChange}
                                                    type="text"
                                                />
                                                <ErrorMessage
                                                    name="subject"
                                                    component="div"
                                                    className="invalid-feedback"
                                                />
                                            </FormGroup>





                                        </Col>
                                        <Col sm="12">
                                            <FormGroup className="mb-3">
                                                <Label htmlFor="ticketType">
                                                    {this.props.t("Issue section *")}
                                                </Label>
                                                <SafeField as="select" name="ticketType"
                                                    className={
                                                        "form-control" +
                                                        (errors.ticketType && touched.ticketType
                                                            ? " is-invalid"
                                                            : "")
                                                    }

                                                    onChange={handleChange}>
                                                    <option value="">Select</option>
                                                    {map(ticketTypes, (ticketType, classkey) => (
                                                        <option value={ticketType.id} key={classkey}>{ticketType.supportTicketTypeTitle}</option>
                                                    ))}
                                                </SafeField>
                                                <ErrorMessage
                                                    name="ticketType"
                                                    component="div"
                                                    className="invalid-feedback"
                                                />
                                            </FormGroup>
                                        </Col>

                                         <Col sm="12">
                                            <FormGroup className="mb-3">
                                                <Label htmlFor="ticketType">
                                                    {this.props.t("Describe issue")}
                                                </Label>
                                                <SafeField
                                                    name="description"
                                                    className={
                                                        "form-control" +
                                                        (errors.description && touched.description
                                                            ? " is-invalid"
                                                            : "")
                                                    }
                                                    onChange={handleChange}
                                                    as="textarea"
                                                />
                                                <ErrorMessage
                                                    name="description"
                                                    component="div"
                                                    className="invalid-feedback"
                                                />
                                            </FormGroup>
                                        </Col>
                                           <Col sm="12">
                                        <div className="form-group mb-3">
                                            <Label htmlFor="file">Attachment</Label>
                                            <input
                                            type="file"
                                            className="form-control"
                                            onChange={event => this.handleFileChange(event, setFieldValue)}
                                            />
                                            <small className="text-muted font-size-12">{UPLOADTEXT.DFOR}</small>
                                           
                                        </div>
                                        </Col>
                                    </Row>






                                    <div><SaveButton>Save</SaveButton></div>

                                </Form>
                            )}
                        </Formik>

                    </OffcanvasBody>
                </Offcanvas>
            </React.Fragment>
        )
    }
}
SupportTicket.propTypes = {
    t: PropTypes.any,
    history: PropTypes.object,
    match: PropTypes.object,


}
const mapStateToProps = () => (
    {



    })
const mapDispatchToProps = dispatch => ({


});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SupportTicket))
